import { useEffect } from 'react';

export default function useBeforeUnloadWarning(isProcessing) {
  useEffect(() => {
    if (!isProcessing) return undefined;

    const handleBeforeUnload = event => {
      event.preventDefault();
      event.returnValue = '';
      return '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isProcessing]);
}
